import type { ReactNode } from "react";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

export type AdminNavItem = {
  path: string;
  label: string;
  icon: ReactNode;
};

export type AdminNavGroup = {
  title: string;
  items: AdminNavItem[];
};

const icon = (Component: typeof SpaceDashboardOutlinedIcon) => (
  <Component sx={{ fontSize: "20px" }} />
);

/**
 * Menu do admin (redesign V3): as mesmas rotas de sempre, com os nomes novos
 * e agrupadas. Quem vê o quê continua vindo de ROLE_ROUTE_ACCESS.
 *
 * Nome novo -> tela atual: Visão geral = Painel de controle; Saúde dos
 * perfis = Qualidade dos perfis; Monitoramento = Perfis em acompanhamento;
 * Carteira de perfis = Perfis ativos; Equipe e acessos = Usuários;
 * Integrações Google = Conectar e-mail.
 */
export const ADMIN_NAV_GROUPS: AdminNavGroup[] = [
  {
    title: "Operação",
    items: [
      { path: "/admin", label: "Visão geral", icon: icon(SpaceDashboardOutlinedIcon) },
      { path: "/profile-quality", label: "Saúde dos perfis", icon: icon(VerifiedUserOutlinedIcon) },
      { path: "/following-profiles", label: "Monitoramento", icon: icon(VisibilityOutlinedIcon) },
    ],
  },
  {
    title: "Carteira",
    items: [
      { path: "/clients", label: "Carteira de perfis", icon: icon(StorefrontOutlinedIcon) },
      { path: "/cases", label: "Casos de sucesso", icon: icon(TrendingUpOutlinedIcon) },
      { path: "/backlinks-dashboard", label: "Backlinks", icon: icon(LinkOutlinedIcon) },
    ],
  },
  {
    title: "Conta",
    items: [
      { path: "/email", label: "Integrações Google", icon: icon(LinkOutlinedIcon) },
      { path: "/sellers", label: "Equipe e acessos", icon: icon(GroupOutlinedIcon) },
    ],
  },
];

export const ADMIN_NAV_ITEMS: AdminNavItem[] = ADMIN_NAV_GROUPS.flatMap((g) => g.items);

/** Título da tela atual para o breadcrumb da barra superior. */
export const adminTitleFor = (pathname: string): string =>
  ADMIN_NAV_ITEMS.find((item) => pathname.startsWith(item.path))?.label ?? "";

export const USER_TYPE_LABEL: Record<string, string> = {
  CUSTOMER: "Cliente",
  PORTFOLIO_MANAGER: "Supervisor de Contas",
  GMAIL_MANAGER: "Conta Google (importador)",
  ADMIN: "Admin",
  STAFF: "Vendedor",
};
